
function capitalizeFirstLetter(string) {
  return string.charAt(0) + string.slice(1)
}

// 找到interface文件夹下以.js命名的文件
const requireComponent = require.context(
  './interface',
  true,
  /\.js$/
)

const interfaceList = {}

requireComponent.keys().forEach(fileName => {
  const a = fileName.lastIndexOf('/')
  const name = '.' + fileName.slice(a)
  const componetName = capitalizeFirstLetter(
    name.replace(/^\.\//, '').replace(/\.\w+$/, '')
  )

  const componetConfig = requireComponent(fileName).default

  interfaceList[componetName] = componetConfig
})

export default interfaceList
